import { Ionicons, MaterialIcons } from "@expo/vector-icons";
import {
	Box,
	Button,
	HStack,
	Icon,
	IconButton,
	StatusBar,
	Text,
	useMediaQuery,
} from "native-base";
import React from "react";
import { Image, Pressable, View } from "react-native";
import { useSelector } from "react-redux";
import AppConstants from "../../utils/Constants";
import {
	getBrandHeaderBackground,
	getBrandHeaderTextColor,
	getBrandLogo,
	getStatusBarContentColor,
	isWeb,
} from "../../utils/utils";

const BRAND_URL = isWeb()
	? AppConstants.WindowHostname
	: AppConstants.CIP_BRAND;

const PublicHeader = ({ props }) => {
	const isDesktopOrLaptop = useMediaQuery({ minWidth: 960 });
	const NavLinks = useSelector((state) => state.Nav.NavLinks);

	const isXiaomi = BRAND_URL === AppConstants.XiaomiURL;

	const navigateTo = (slug) => {
		let Element = document.getElementById(`${slug}`);

		if (Element) {
			Element.scrollIntoView({ behavior: "smooth", block: "center" });
		} else {
			props.navigation.navigate("Home");

			setTimeout(function () {
				document
					.getElementById(`${slug}`)
					?.scrollIntoView({ behavior: "smooth", block: "center" });
			}, 500);
		}
	};

	return (
		<>
			<StatusBar barStyle={getStatusBarContentColor()} />
			<Box safeAreaTop bg={getBrandHeaderBackground()} />
			<View>
				<HStack
					bg={getBrandHeaderBackground()}
					px="2"
					justifyContent="space-between"
					alignItems="center"
				>
					<HStack space="4" alignItems="center" justifyContent="space-between">
						{isDesktopOrLaptop[0] === false && (
							<IconButton
								onPress={() => props.navigation.toggleDrawer()}
								icon={
									<Icon
										color={getBrandHeaderTextColor()}
										size="sm"
										as={<MaterialIcons name="menu" />}
									/>
								}
							/>
						)}
						{isDesktopOrLaptop[0] === true ? (
							<Pressable onPress={() => props.navigation.navigate("Home")}>
								<Image
									resizeMode="contain"
									source={{
										uri: isWeb()
											? getBrandLogo()
											: Image.resolveAssetSource(getBrandLogo()).uri,
									}}
									style={{
										width: 200,
										height: 50,
										marginVertical: 5,
										marginLeft: isWeb() ? 50 : "auto",
									}}
								/>
							</Pressable>
						) : (
							<>
								{props.route.name === "Login" ? (
									<Image
										resizeMode="contain"
										source={{
											uri: isWeb()
												? getBrandLogo()
												: Image.resolveAssetSource(getBrandLogo()).uri,
										}}
										style={{
											width: 250,
											height: 50,
										}}
									/>
								) : (
									<Text
										color={getBrandHeaderTextColor()}
										fontSize="20"
										fontWeight="900"
									>
										{props.route.name}
									</Text>
								)}
							</>
						)}
					</HStack>
					{isDesktopOrLaptop[0] && (
						<HStack space="2" alignItems="center" textTransform="capitalize">
							{NavLinks?.data.map((item, index) => {
								let meta = item.meta_data;
								if (meta.location == "main") {
									if (item.children !== undefined && item.children.length > 0) {
										let hasFirst = false;
										let children = item.children.map((c_item) => {
											let meta = c_item.meta_data;
											if (meta.cast_as_anchor == true) {
												let anchor = c_item.slug;

												if (!hasFirst) {
													hasFirst = true;
													return (
														<Button
															testID={meta?.id}
															key={index + Math.random()}
															onPress={() =>
																props.navigation.navigate(item.page_title)
															}
															variant="ghost"
														>
															<Text
																color={getBrandHeaderTextColor()}
																fontSize="12"
																fontWeight="semibold"
															>
																{item.page_title.toUpperCase()}
															</Text>
														</Button>
													);
												}
												return (
													<Button
														testID={meta?.id}
														key={index + Math.random()}
														onPress={() =>
															// props.navigation.navigate(c_item.page_title)
															navigateTo(c_item.slug)
														}
														variant="ghost"
													>
														<Text
															color={getBrandHeaderTextColor()}
															fontSize="12"
															fontWeight="semibold"
														>
															{c_item.page_title.toUpperCase()}
														</Text>
													</Button>
												);
											}
										});

										return children;
									} else {
										if (meta.icon) {
											return (
												<Button
													testID={meta?.id}
													key={index + Math.random()}
													onPress={() =>
														props.navigation.navigate(item.page_title)
													}
													variant="ghost"
													leftIcon={
														<Icon
															as={Ionicons}
															name={meta.icon === "user" ? "person" : meta.icon}
															size="xs"
														/>
													}
												>
													<Text
														color={getBrandHeaderTextColor()}
														fontSize="12"
														fontWeight="semibold"
													>
														{item.page_title.toUpperCase()}
													</Text>
												</Button>
											);
										} else {
											return (
												<>
													<Button
														testID={meta?.id}
														key={index + Math.random()}
														onPress={() =>
															props.navigation.navigate(item.page_title)
														}
														variant="ghost"
													>
														<Text
															color={getBrandHeaderTextColor()}
															fontSize="12"
															fontWeight="semibold"
														>
															{item.page_title.toUpperCase()}
														</Text>
													</Button>
												</>
											);
										}
									}
								}
							})}
						</HStack>
					)}
				</HStack>
				{isXiaomi && (
					<View
						style={{ backgroundColor: "#F26A21", height: 6, width: "100%" }}
					/>
				)}
			</View>
		</>
	);
};

export default PublicHeader;
